<template>
    <TheModal class="sm" @close="close">
        <template v-slot:head>
            Настройка программы лояльности
        </template>

        <FormLoyaltySettings ref="vm_loyalty" :loyalty="loyalty" :pending="pending" @save="save" />
    </TheModal>
</template>

<script>
import TheModal from '@/components/TheModal'
import FormLoyaltySettings from '@/components/FormLoyaltySettings'
import store from '@/store'
import { toastSuccess, toastError } from '@/dialogs'
import cloneDeep from 'lodash/cloneDeep'

export default {
    components: {
        TheModal,
        FormLoyaltySettings
    },

    data() {
        const loyalty = cloneDeep(store.getters['vm/loyalty'])

        return {
            loyalty: loyalty,
            pending: false
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'vm', params: this.$route.params.id }).catch(() => {})
        },

        async save(loyalty) {
            this.pending = true
            const success = await this.$store.dispatch('vm/loyalty/save', { vmId: this.$route.params.id, loyalty })
            this.pending = false

            if (success) {
                toastSuccess('Изменения сохранены')
                this.close()
            } else {
                toastError('Ошибка сохранения')
                this.$refs.vm_loyalty.mixinApiErrors(this.$store.state.vm.loyalty.error)
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        const done = await store.dispatch('vm/loyalty/fetch', to.params.id)

        return done ? next() : next({ name: 'vms' })
    }
}
</script>
